<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <form @submit.prevent="handleSubmit">
                <h1>Reset your password</h1>
                <p class="text-muted">Enter your email address below and we'll send you a link to reset your password.</p>
                <b-alert variant="info" dismissible :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false">
                  {{dismissibleMessage}}
                </b-alert>
                <b-input-group class="mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="icon-envelope"></i></span>
                  </div>
                  <input type="text" class="form-control" placeholder="Your Email" v-model="useremail">
                </b-input-group>

                <b-button variant="primary" class="px-4" type="submit" v-bind:disabled="!isValid" block>Send reset password email</b-button>
              </form>
            </b-card-body>
            <b-card-footer>
              <b-row>
                <b-col cols="12" class="text-center text-muted">
                  Already have an account? <b-button variant="link" class="px-0" href="#/pages/signin">Sign in</b-button>
                </b-col>
              </b-row>
            </b-card-footer>           
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'forgotpassword',
    data: function () {
      return {
        apiHost: window.apiHost,
        apiUri: window.apiUri,
        showDismissibleAlert: false,
        dismissibleMessage: '',
        useremail: ''
      }
    },
    computed: {
      isValid: function () {
        return this.useremail !== ''
      }
    },
    methods: {
      handleSubmit: function () {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.headers.common['Accept'] = 'application/json'
        this.showDismissibleAlert = false
        this.dismissibleMessage = ''

        let data = this
        let uri = this.apiHost + 'oauth/token'
        axios.post(uri,
          {})
          .then(function (response) {
            data.showDismissibleAlert = true
            data.dismissibleMessage = 'We sent an email with instructions to reset your password.'
          })
          .catch(function (error) {
            // Wu oh! Something went wrong
            console.log(error.response.statusText)
            data.showDismissibleAlert = true
            data.dismissibleMessage = 'Something went wrong. Please try again.'
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue